import { useLocation } from 'react-router-dom';
import SearchParams from './SearchParams';

const useSearchParams = () => {
	const location = useLocation();
	const urlSearchParams = new URLSearchParams(location.search);
	const searchParams = new SearchParams(urlSearchParams, location);

	return Object.freeze(searchParams);
};

export default useSearchParams;
